import { NavRoutes } from "../enums/header-items";

const getRouteFromCategory = (category: string): string => {
  switch (category) {
    case NavRoutes.EVENTS:
      return "/content?category=EVENTS";
    case NavRoutes.POPUPS:
      return "/content?category=POP%20UPS";
    case NavRoutes.RETAIL:
      return "/content?category=RETAIL%20SPACES";
    default:
      return "/";
  }
};

export default getRouteFromCategory